export default {
  items: [
    {
      name: "Dashboard",
      url: "/admin/document-drafting/dashboard",
      icon: "isax-category-2",
      meta: {
      allowAccess: ["*"],
      page: "admin",
      code: ["*"],
        collection: 'DocumentDrafting'
      }
    },
    {
      name: "Danh sách văn bản",
      url: "/admin/document-drafting/list",
      icon: "isax-directbox-notif",
      meta: {
        allowAccess: ["*"],
        page: "admin",
        code: ["*"],
        collection: 'DocumentDrafting'
      }
    },
    {
      name: "Tạo văn bản",
      url: "/admin/document-drafting/create",
      activeurl: [
        "/admin/document-drafting/create",
        "/admin/document-drafting/create-drafting"
      ],
      icon: "isax-sms-tracking",
      meta: {
        allowAccess: ["*"],
        page: "admin",
        code: ["*"],
        collection: 'DocumentDrafting'
      }
    },
    {
      name: "Quản lý loại mẫu",
      url: "/admin/document-drafting/template-categories",
      icon: "isax-task-square",
      meta: {
        allowAccess: ["*"],
        page: "admin",
        code: ["*"],
        collection: "DocumentDrafting"
      }
    },
    {
      name: "Quản lý mẫu văn bản",
      url: "/admin/document-drafting/templates",
      icon: "isax-document-text",
      meta: {
        allowAccess: ["*"],
        page: "admin",
        code: ["*"],
        collection: "DocumentDrafting"
      }
    },
    // {
    //   name: "Test",
    //   url: "/admin/document-drafting/test",
    //   icon: "isax-sms-tracking",
    //   meta: {
    //     allowAccess: ["*"],
    //     page: "admin",
    //     code: ["*"],
    //     collection: 'DocumentDrafting'
    //   }
    // },
  ]
 }
